<template>
  <div id="app" class="app">
    <div v-if="localeIsLoading" class="app__loader">
      <v-progress-circular indeterminate />
    </div>

    <router-view v-else />
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useLocaleStore } from '@/stores/locale';

export default {
  name: 'App',

  provide() {
    return {
      media: this.media,
    };
  },

  data: () => ({
    media: {
      isMobile: false,
      md: false,
      sm: false,
      xs: false,
    },
  }),

  computed: {
    ...mapState(useLocaleStore, ['languagesListLoading']),

    isAdminPanel() {
      return this.$route.path.startsWith('/admin-panel');
    },

    localeIsLoading() {
      return !this.isAdminPanel && this.languagesListLoading;
    },
  },

  watch: {
    // Vuetify 3: breakpoint → display (upgrade guide)
    '$vuetify.display': {
      immediate: true,
      deep: true,
      handler(display) {
        this.media.isMobile = display.sm || display.xs;
        this.media.md = display.md;
        this.media.sm = display.sm;
        this.media.xs = display.xs;
      },
    },
  },

  async mounted() {
    await this.$router.isReady();

    if (!this.isAdminPanel) {
      useLocaleStore().fetchLanguagesList();
    }
  },
};
</script>

<style lang="scss">
.app {
  &__loader {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 100vh;
    color: $--primary-color;
  }
}
</style>
